// https:// medium.com/@.gc/hi-i-thought-about-automating-this-and-came-up-via-two-decorators-require-and-e370811b5fc9
/**
 * @param args
 */
export function Require<T>(args: Array<keyof T>) {
  return function requiredFtn(target) {
    const prototype: T = target.prototype;
    const onInit = prototype['ngOnInit'] ? prototype['ngOnInit'].bind(target) : () => {};

    prototype['ngOnInit'] = function check() {
      args.forEach((arg) => {
        if (!this[arg]) {
          console.error(`Property "${String(arg)}" is required`);
        }
      });

      onInit();
    };
  };
}
